export const SET_INTRO_STEP_PROP = 'SET_INTRO_STEP_PROP';
export const SET_INTRO_STEP_DATA = 'SET_INTRO_STEP_DATA';

export const SET_APP_STATE = 'SET_APP_STATE';
export const SET_PROCESS_STATE = 'SET_PROCESS_STATE';
export const SET_APP_EDIT_TARGET_TYPE = 'SET_APP_EDIT_TARGET_TYPE';
export const SET_EDITOR_PANEL_TITLE = 'SET_EDITOR_PANEL_TITLE';
export const UPDATE_HINT = 'UPDATE_HINT';
export const CLOSE_HINT = 'CLOSE_HINT';
export const ADD_CHANGE = 'ADD_CHANGE';
export const CLEAR_CHANGES = 'CLEAR_CHANGES';
export const CLEAR_ALL_CHANGES = 'CLEAR_ALL_CHANGES';
export const RESTORE_ALL_CHANGES = 'RESTORE_ALL_CHANGES';
export const ON_ADD_NEW_STEP_AT = 'ON_ADD_NEW_STEP_AT';
export const ON_REMOVE_STEP_AT = 'ON_REMOVE_STEP_AT';
export const SET_CURRENT_STEP_CORE = 'SET_CURRENT_STEP_CORE';
export const SET_STEP_COUNT = 'SET_STEP_COUNT';
export const STEP_CHANGING_IN_PROGRESS = 'STEP_CHANGING_IN_PROGRESS';
export const SET_EDIT_PANEL_STATE = 'SET_EDIT_PANEL_STATE';
export const SET_TARGET_TYPE = 'SET_TARGET_TYPE';
export const SET_ORIGIN = 'SET_ORIGIN';
export const SET_TOTAL_SAVED_CHANGES = 'SET_TOTAL_SAVED_CHANGES';
export const SET_CONTROLS_POSITION = 'SET_CONTROLS_POSITION';
export const SET_MOBILE_MENU_OPENER_SELECTED = 'SET_MOBILE_MENU_OPENER_SELECTED';
export const SET_MOBILE_ALT_STEP_MODE = 'SET_MOBILE_ALT_STEP_MODE';
export const UPDATE_NAVIG_BUTTON_HOVERED = 'UPDATE_NAVIG_BUTTON_HOVERED';
export const UPDATE_TARGET_EDIT_DETAIL_OPENED = 'UPDATE_TARGET_EDIT_DETAIL_OPENED';
export const UPDATE_CLOSE_MENU_OPENED = 'UPDATE_CLOSE_MENU_OPENED';
export const UPDATE_INTERACTION_EDIT_DETAIL_OPENED = 'UPDATE_INTERACTION_EDIT_DETAIL_OPENED';
export const TOGGLE_CANCEL_BUTTON_POS = 'TOGGLE_CANCEL_BUTTON_POS';
export const SET_CANCEL_BUTTON_POS = 'SET_CANCEL_BUTTON_POS';
